import React, { useCallback, useState } from 'react';
import {
    Button,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Heading,
    Input
} from '@chakra-ui/react';
import { useOutletContext } from 'react-router-dom';
import { useTranslate } from 'ts/common/hooks';
import type { QuestionnaireContext } from 'client_react/questionnaire/QuestionnaireApp';
import QuestionnaireContent from 'client_react/questionnaire/components/QuestionnaireContent';

const QuestionnairePage: React.FC = () => {
    const t = useTranslate('clientQuestionnaire');

    const { fetchQuestionnaire, loading, error, questionnaire } =
        useOutletContext<QuestionnaireContext>();

    const [email, setEmail] = useState('');

    const handleSubmit = useCallback(
        async (e: React.FormEvent) => {
            e.preventDefault();

            if (!email.trim()) {
                return;
            }

            await fetchQuestionnaire(email.trim());
        },
        [email, fetchQuestionnaire]
    );

    if ('pages' in questionnaire) {
        return <QuestionnaireContent />;
    }

    return (
        <Flex flexDirection="column" alignItems="center">
            <Heading as="h3" size="md" fontSize="20px" mb={6} textAlign="center">
                {t('emailHeading')}
            </Heading>
            <Flex
                as="form"
                onSubmit={handleSubmit}
                flexDirection="column"
                alignItems="center"
                maxWidth="350px"
                width="100%"
            >
                <FormControl isInvalid={!!error} isRequired mb={4}>
                    <FormLabel>{t('email')}</FormLabel>
                    <Input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete="email"
                    />
                    <FormErrorMessage>
                        {error?.status === 403 ? t('emailError') : error?.detail}
                    </FormErrorMessage>
                </FormControl>
                <Button type="submit" variant="primary" isLoading={loading}>
                    {t('viewQuestionnaire')}
                </Button>
            </Flex>
        </Flex>
    );
};

export default QuestionnairePage;
